import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

export const isDemoMode = !process.env.REACT_APP_FIREBASE_API_KEY;
export const isEmulator = process.env.REACT_APP_USE_EMULATOR === "true";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "demo",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "demo.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "demo",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "demo.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "000",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:000:web:000",
};

const app = initializeApp(firebaseConfig);
const auth = isDemoMode ? null : getAuth(app);
const db = isDemoMode ? null : getFirestore(app);
const storage = isDemoMode ? null : getStorage(app);

if (!isDemoMode && isEmulator) {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8080);
  connectStorageEmulator(storage, "localhost", 9199);
}

export { app, auth, db, storage };
